export function HuiPageContent() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui hui-page-content d-contents" ng-transclude></div>`;
        }
    };
}

export function HuiPageContentAttribute() {
    return {
        restrict: 'A',
        scope: true,
        transclude: false,
        link: ($scope, element, attrs) => {
            element.addClass('hui hui-page-content d-contents');
        }
    };
}